
import React from "react";
import { DisabledPrompt, useStateManager } from "@bcm-dev/bcms-vite";
import { SVGAsset } from "res";
import "./styles.css";

export default function ChatFeaturePopup(props) {
  const { data, ui, onUIClick } = useStateManager();
  const { showFeaturePopup } = ui ?? {};
  const openClass = showFeaturePopup ? "open" : "";

  return (
    <div className={`chat-popup feature-popup ${openClass}`}>
      <div className="feature-popup-container flex-container flex-vertical">
        <div className="flex-container flex-horizontal align-center feature-header">
          <div className="flex-width"></div>
          <div className="set-width clickable" onClick={onUIClick("showFeaturePopup", false)} >
            <SVGAsset id="MinusIcon" className="minus-icon feature-icon clickable" />
          </div>
        </div>
        <div className="flex-container flex-horizontal align-center feature-item">
          <div className="set-width">
            {/* <div className="speaker-icon feature-icon" data-bcms-svg="speaker-icon"></div> */}
            <SVGAsset id="SpeakerIcon" className="speaker-icon feature-icon" />
          </div>
          <div className="flex-width">
            <p className="feature-text">Start Voice</p>
          </div>
        </div>
        <div className="flex-container flex-horizontal align-center feature-item">
          <div className="set-width">
            {/* <div className="camera-icon feature-icon" data-bcms-svg="camera-icon"></div> */}
            <SVGAsset id="ChatCameraIcon" className="camera-icon feature-icon" />
          </div>
          <div className="flex-width">
            <p className="feature-text">Start Video</p>
          </div>
        </div>
        <div className="flex-container flex-horizontal align-center feature-item">
          <div className="set-width">
            {/* <div className="monitor-icon feature-icon" data-bcms-svg="monitor-icon"></div> */}
            <SVGAsset id="ChatMonitorIcon" className="monitor-icon feature-icon" />
          </div>
          <div className="flex-width">
            <p className="feature-text">Share Desktop</p>
          </div>
        </div>
        <div className="flex-container flex-horizontal align-center feature-item">
          <div className="set-width">
            {/* <div className="paper-clip-icon feature-icon" data-bcms-svg="paper-clip-icon"></div> */}
            <SVGAsset id="ChatPaperClipIcon" className="paper-clip-icon feature-icon" />
          </div>
          <div className="flex-width">
            <p className="feature-text">Upload File</p>
          </div>
        </div>
        <DisabledPrompt>
          <div className="flex-container flex-horizontal align-center feature-item active-item clickable">
            <div className="set-width ">
              {/* <div className="gear-setting-icon feature-icon" data-bcms-svg="gear-setting-icon"></div> */}
              <SVGAsset id="ChatGearIcon" className="gear-setting-icon feature-icon" />
            </div>
            <div className="flex-width">
              <p className="feature-text">Settings</p>
            </div>
          </div>
        </DisabledPrompt>

      </div>
    </div>
  )
}
